<div class="verify-account-container">
  <div>
    <app-label
        ngProjectAs="name"
        [text]="'Bank Account Details'">
    </app-label>
  </div>
  <br>
  <br>
  <br>
  <br>
  <app-form-row>
    <app-label
        ngProjectAs="name"
        [text]="'UPI ID'">
    </app-label>
    <app-textbox
        [placeholder]="'1234567890@upi'"
        [hintText]="'Please enter UPI ID'"
        [control]="accountControl"
        [maxLength]="25">
    </app-textbox>
  </app-form-row>
  <app-form-row>
    <app-label
        ngProjectAs="name"
        [text]="'OTP Code'">
    </app-label>
    <app-textbox
        [placeholder]="'code-validation-txt' | transloco"
        [hintText]="'Enter OTP code received on Mobile'"
        [control]="mobileOTP"
        [maxLength]="6">
    </app-textbox>
  </app-form-row>

  <app-form-row>
    <app-button [button]="resendOTPButton">
    </app-button>
  </app-form-row>
  <app-button [button]="verifyAccountButton">
  </app-button>
</div>

<app-loading-dimmer [active]="loading"></app-loading-dimmer>

<ng-template #errorMsg>
  <app-label
    [text]="'You have reached the maximum attempts. Need help? Contact support or try next day'">
  </app-label>
</ng-template>

<ng-template #errorMsgInvalidToken>
  <app-label
    [text]="'Invalid Token'">
  </app-label>
</ng-template>

<ng-template #successMsgHeader>
  <div class="dialog-header">
    <span mat-dialog-title>Success</span>
  </div>
</ng-template>

<ng-template #successMsg>
  <app-label
    [text]="'Account added successfully!'">
  </app-label>
</ng-template>

<ng-template #otpMsg>
  <app-label
    [text]="'OTP is send on Mobile'">
  </app-label>
</ng-template>
